import React, { Component } from "react";
import moment from "moment";
import helperFunctions from "../../../utils/functions";
import Bridge from "../../../utils/Bridge";
import { Spin } from "antd";

export default class Alsfrsr extends Component {
  constructor(props) {
    super(props);
    this.state = {
      records: [],
      loading: false,
    };
  }
  componentDidMount() {
    this.get_eals_frs_list();
  }
  get_eals_frs_list = () => {
    this.setState({ loading: true });
    let params = "?eals_id=" + localStorage.getItem("ap_eals_id");
    Bridge.personal_data_viewer.le_study
      .get_le_study_eals_frs_score(params)
      .then((res) => {
        if (res.status == "1") {
          this.setState({
            records: res.data,
          });
        }
        this.setState({ loading: false });
      })
      .catch((err) => {
        this.setState({ loading: false });
      });
  };
  render() {
    const formData = this.props.language;
    return (
      <div className="als_frs_sessions">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 px-0">
              <Spin spinning={this.state.loading}>
                {this.state.records.length > 0 && (
                  <table>
                    <tr>
                      <th>{formData.page.personalDataViewer.alsfrsr.date}</th>
                      <th>{formData.page.personalDataViewer.alsfrsr.speech}</th>
                      <th>{formData.page.personalDataViewer.alsfrsr.salvation}</th>
                      <th>{formData.page.personalDataViewer.alsfrsr.swallowing}</th>
                      <th>{formData.page.personalDataViewer.alsfrsr.handwriting}</th>
                      <th>{formData.page.personalDataViewer.alsfrsr.cuttingFood}</th>
                      <th>{formData.page.personalDataViewer.alsfrsr.dressingAndHygiene}</th>
                      <th>{formData.page.personalDataViewer.alsfrsr.turningInBed}</th>
                      <th>{formData.page.personalDataViewer.alsfrsr.walking}</th>
                      <th>{formData.page.personalDataViewer.alsfrsr.climbingStairs}</th>
                      <th>{formData.page.personalDataViewer.alsfrsr.dyspnea}</th>
                      <th>{formData.page.personalDataViewer.alsfrsr.orthopnea}</th>
                      <th>{formData.page.personalDataViewer.alsfrsr.respiratoryInsufficiency}</th>
                      <th>{formData.page.personalDataViewer.alsfrsr.total}</th>
                    </tr>
                    {this.state.records &&
                      this.state.records.map((item, index) => {
                        let speechColor = helperFunctions.getColor(item.speech);
                        let salavationColor = helperFunctions.getColor(
                          item.salvation
                        );
                        let swallowingColor = helperFunctions.getColor(
                          item.swallowing
                        );
                        let handwritingColor = helperFunctions.getColor(
                          item.handwriting
                        );
                        let cutting_food_value = "";
                        let cuttingFoodColor = helperFunctions.getColor(
                          item.cutting_food_a
                        );
                        if (item.cutting_food_a) {
                          cutting_food_value = item.cutting_food_a;
                          cuttingFoodColor = helperFunctions.getColor(
                            item.cutting_food_a
                          );
                        } else if (item.cutting_food_b) {
                          cutting_food_value = item.cutting_food_b;
                          cuttingFoodColor = helperFunctions.getColor(
                            item.cutting_food_b
                          );
                        }

                        let dressingColor = helperFunctions.getColor(
                          item.dressing_and_hygiene
                        );
                        let turingColor = helperFunctions.getColor(
                          item.turning_in_bed
                        );
                        let walkingColor = helperFunctions.getColor(item.walking);
                        let climbingColor = helperFunctions.getColor(
                          item.climbing_stairs
                        );
                        let dyspneaColor = helperFunctions.getColor(item.dyspnea);
                        let orthopneaColor = helperFunctions.getColor(
                          item.orthopnea
                        );
                        let respiratoryColor = helperFunctions.getColor(
                          item.respiratory_insufficiency
                        );
                        return (
                          <tr key={index}>
                            <td>
                              {item.created_at
                                ? moment(item.created_at).format("MM/DD/YYYY")
                                : "---"}
                            </td>
                            <td class={speechColor}>{item.speech}</td>
                            <td class={salavationColor}>{item.salvation}</td>
                            <td class={swallowingColor}>{item.swallowing}</td>
                            <td class={handwritingColor}>{item.handwriting}</td>
                            <td class={cuttingFoodColor}>{cutting_food_value}</td>
                            <td class={dressingColor}>
                              {item.dressing_and_hygiene}
                            </td>
                            <td class={turingColor}>{item.turning_in_bed}</td>
                            <td class={walkingColor}>{item.walking}</td>
                            <td class={climbingColor}>{item.climbing_stairs}</td>
                            <td className={dyspneaColor}>{item.dyspnea}</td>
                            <td className={orthopneaColor}>{item.orthopnea}</td>
                            <td className={respiratoryColor}>
                              {item.respiratory_insufficiency}
                            </td>
                            <td>{item.ALS_total}</td>
                          </tr>
                        );
                      })}
                  </table>
                )}
                {this.state.records.length == 0 && (
                  <div className="col-lg-12">
                    <div
                      style={{
                        fontSize: 20,
                        textAlign: "center",
                        padding: 20,
                      }}
                    >
                      {this.props.language.page.notAvailable}
                    </div>
                  </div>
                )}
              </Spin>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
